import React from 'react';

// --- Mock Data (for CashFlow) ---
export const REPORT_DATA = {
  cashFlow: {
    operating: [
      { name: "Net Income", value: 1110000 },
      { name: "Adjustments for Depreciation", value: 110000 },
      { name: "Decrease in Tuition Receivable", value: 45000 },
      { name: "Increase in Deferred Revenue", value: 200000 },
      { name: "Decrease in Accounts Payable", value: -30000 },
    ],
    investing: [
      { name: "Purchase of New School Bus", value: -120000 },
      { name: "Upgrade of Science Lab", value: -50000 },
    ],
    financing: [
      { name: "Repayment of Bank Loan", value: -100000 },
      { name: "Dividend/Distribution to Owners", value: -200000 },
    ],
  },
};

// --- Helper Functions ---
export const formatCurrency = (amount) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);

export const SectionHeader = ({ title, total, type = "neutral" }) => {
  let textColor = 'text-dark';
  if (type === 'positive') textColor = 'text-success';
  if (type === 'negative') textColor = 'text-danger';

  return (
    <div className="d-flex justify-content-between align-items-center py-2 px-3 bg-light border-bottom mt-4 rounded-top">
      <h6 className={`mb-0 fw-bold text-muted text-uppercase ${textColor}`} style={{ fontSize: '0.75rem' }}>{title}</h6>
      <span className={`fw-bold font-monospace ${textColor}`}>{total}</span>
    </div>
  );
};

export const LineItem = ({ name, value, indent = false }) => (
  <div className={`d-flex justify-content-between align-items-center py-2 px-3 border-bottom ${indent ? 'ps-4' : ''}`}>
    <span style={{ fontSize: '0.875rem' }} className="text-dark">{name}</span>
    <span className="font-monospace text-muted" style={{ fontSize: '0.875rem' }}>{value}</span>
  </div>
);
